// extracted by mini-css-extract-plugin
module.exports = {"listItem":"listItem__cfFIy","name":"name__ZOMG9","badge":"badge__OPBj1"};